var map = {
	"./Chemistry.png": 1935,
	"./Geography.png": 2584,
	"./History.png": 4412,
	"./Organism.png": 7651,
	"./Physics.png": 1683,
	"./Politics.png": 5246,
	"./camera_upload.png": 2479,
	"./compute_icon.png": 6542,
	"./correcting_icon.png": 6928,
	"./edit_img.png": 9951,
	"./esearch_icon.png": 9534,
	"./flag_icon.png": 8290,
	"./image@2x(1).png": 3288,
	"./image@2x.png": 8444,
	"./no_data.png": 392,
	"./recording_img.png": 3849,
	"./search_icon.png": 532,
	"./search_img.png": 6009,
	"./容器@2x(1).png": 3282,
	"./容器@2x(2).png": 7078,
	"./容器@2x(3).png": 5828,
	"./容器@2x(3)1.png": 1849,
	"./容器@2x(4).png": 1961,
	"./容器@2x(4)1.png": 2,
	"./容器@2x(5).png": 3818,
	"./容器@2x(5)1.png": 7795,
	"./容器@2x(6).png": 9343,
	"./容器@2x.png": 8797,
	"./组 786@2x.png": 6901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5768;